import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import Util from "../../Util"
import Moment from "moment"
class TableNotasFiscaisNav extends Component {
  render() {
    var tableHeaders = [
      "Número da nota fiscal",
      "Data da nota fiscal",
      "Número de itens baixados",
      "Número do contrato",
      "Objeto do contrato",
      "Valor da nota",
      "Ações"
    ]
    return (
      <table className="table table-hover">
        <thead className="text-warning">
          <tr>
            {tableHeaders.map((header, key) => {
              return <th key={key}>{header}</th>
            })}
          </tr>
        </thead>
        <tbody>
          {this.props.rows.map((row, key) => {
            return (
              <tr key={key}>
                <td className="col-md-1">{row.numero}</td>
                <td className="col-sm-1">
                  {Moment(row.data).format("D/MM/Y")}
                </td>
                <td className="col-sm-1">{row.itens_nota.length}</td>
                <td className="col-sm-1">{row.contrato.num_contrato}</td>
                <td className="col-sm-6">{row.contrato.objeto}</td>
                <td className="col-sm-2">
                  {Util.formatCurrency(parseFloat(row.valor))}
                </td>
                <td className="td-actions text-right">
                  <Link
                    title="Ir para a tela de baixas"
                    className="btn btn-primary btn-simple btn-xs"
                    to={"/notas/" + row.contrato.id}
                  >
                    <i className="material-icons">forward</i>
                  </Link>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
}
export default withRouter(TableNotasFiscaisNav)



// WEBPACK FOOTER //
// ./src/views/baixas/TableNotasFiscaisNav.js